import AccountModalHeader from "./AccountModalHeader";

export default AccountModalHeader;
